import { Servicetrac } from "./Servicetrac.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Servicetrac
};
//# sourceMappingURL=index.js.map
